import { Box, Chip, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { palette } from "../../theme";
import { MUTED, SURFACE, SURFACE_HEAD, BORDER } from "../dashboard/dashboard-components/resellerUi";

dayjs.extend(utc);
dayjs.extend(timezone);

// Mattoncini condivisi dell'area ticket reseller (badge, ricerca, filtri, date, dialog).

// Date del server: o ISO (hardware) o stringa "D/MM/YYYY HH:mm:ss" già in ora locale
// del server (ticket di supporto). Ritorna { label: "DD/MM/YYYY HH:mm", ts } oppure null.
const LOCAL_DATE = /^(\d{1,2})\/(\d{1,2})\/(\d{4})[ T](\d{1,2}):(\d{2})/;

export const parseDate = (v) => {
  if (!v || /NaN/.test(String(v))) return null;
  const m = LOCAL_DATE.exec(String(v));
  if (m) {
    const [, d, mo, y, h, mi] = m;
    const date = dayjs(new Date(Number(y), Number(mo) - 1, Number(d), Number(h), Number(mi)));
    return date.isValid() ? { label: date.format("DD/MM/YYYY HH:mm"), ts: date.valueOf() } : null;
  }
  const date = dayjs(v);
  if (!date.isValid()) return null;
  const tz = sessionStorage.getItem("timezone") || "Europe/Rome";
  return { label: date.tz(tz).format("DD/MM/YYYY HH:mm"), ts: date.valueOf() };
};

export const formatDate = (v) => parseDate(v)?.label ?? "-";

export const Muted = ({ children }) => (
  <Typography component="span" sx={{ fontSize: 13, color: MUTED }}>{children}</Typography>
);

// Badge outlined come SevBadge di Tiresia.
export const StatusBadge = ({ color, children }) => (
  <Box
    component="span"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      px: 0.8,
      py: 0.15,
      color,
      bgcolor: `${color}22`,
      border: `1px solid ${color}`,
      borderRadius: 0.5,
      fontSize: 11,
      fontWeight: 700,
      lineHeight: 1.4,
      textTransform: "uppercase",
      whiteSpace: "nowrap",
    }}
  >
    {children}
  </Box>
);

export const SearchField = ({ value, onChange, placeholder }) => (
  <TextField
    size="small"
    placeholder={placeholder}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    sx={{ minWidth: 240, flex: 1, maxWidth: 360 }}
    slotProps={{
      input: {
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: MUTED }} />
          </InputAdornment>
        ),
      },
    }}
  />
);

// options: [{ key, label, count }]
export const FilterChips = ({ options, value, onChange }) => (
  <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
    {options.map(({ key, label, count }) => {
      const active = value === key;
      return (
        <Chip
          key={key}
          size="small"
          clickable
          onClick={() => onChange(key)}
          label={`${label} · ${count}`}
          sx={{
            color: active ? "#eaeaea" : MUTED,
            backgroundColor: active ? "rgba(69,144,149,0.18)" : "transparent",
            border: "1px solid",
            borderColor: active ? palette.primary.main : "rgba(255,255,255,0.14)",
            "&:hover": { borderColor: palette.primary.light, backgroundColor: "rgba(69,144,149,0.12)" },
          }}
        />
      );
    })}
  </Stack>
);

export const dialogPaperProps = {
  paper: {
    sx: {
      backgroundColor: SURFACE,
      backgroundImage: "none",
      border: `1px solid ${BORDER}`,
      borderRadius: "10px",
    },
  },
};

export const dialogTitleSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
  py: 1.25,
  backgroundColor: SURFACE_HEAD,
  fontSize: 16,
  fontWeight: 700,
};

// Stato numerico del ticket di supporto -> etichetta/colore.
export const TICKET_STATUS = {
  1: { label: "New", color: "#EF9F27" },
  2: { label: "Working", color: palette.primary.light },
  3: { label: "Finished", color: "#34a327" },
};

// Pannello a tutta altezza viewport (Panel ha un'altezza fissa di default).
export const panelSx = { height: "calc(100vh - 340px)", minHeight: 420 };
